@import 'styles/mixins';

.root {
  transform: scale(1);
  perspective: 600px;
  position: relative;
  transition: all 250ms ease-out;
  display: flex;
  flex-direction: column;
  min-width: 0;

  &.fullWidth {
    flex: 1;
    width: 100%;
  }

  &:hover {
    --scale: calc((100 + var(--popout-percentage, 5)) / 100);
    z-index: 10;
    transform: scale(var(--scale, 1.1));
  }
}

.content {
  transition: all 250ms ease-out;
  perspective: 600px;
  transform: scale(1);
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
